import { render, staticRenderFns } from "./loyaltyStoreOrder.vue?vue&type=template&id=af8007d0&"
import script from "./loyaltyStoreOrder.vue?vue&type=script&lang=js&"
export * from "./loyaltyStoreOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports